import { render, staticRenderFns } from "./NisSicknessForm.vue?vue&type=template&id=f4ca0e62"
import script from "./NisSicknessForm.vue?vue&type=script&lang=js"
export * from "./NisSicknessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports